"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const components_1 = require("./components");
const CarouselButton_1 = __importDefault(require("./CarouselButton"));
const groupArray_1 = require("./utils/groupArray");
const calculateStyle_1 = require("./utils/calculateStyle");
// styles
require("./carousel.scss");
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-carousel",
    style: {},
    children: [],
    className: "",
    showPagination: true,
    slideClassName: "",
    sliderClassName: "",
    slidesPerView: 1,
    centeredSlides: false,
    width: "100%",
    selectedItemIndex: 0,
    onChange: () => { },
    loop: true,
};
const Carousel = (_a) => {
    var { className, children, buttons, style, showPagination, slidesPerView, centeredSlides, slideClassName, sliderClassName, width, selectedItemIndex, onChange, loop } = _a, rest = __rest(_a, ["className", "children", "buttons", "style", "showPagination", "slidesPerView", "centeredSlides", "slideClassName", "sliderClassName", "width", "selectedItemIndex", "onChange", "loop"]);
    const classContainerList = (0, classnames_1.default)("tecma-carousel", className);
    const classSliderList = (0, classnames_1.default)("slider", sliderClassName);
    const wrapperClassList = (0, classnames_1.default)("slider-wrapper", { centered: centeredSlides, loop });
    const carouselWrapperRef = (0, react_1.useRef)(null);
    /*
     * create a copy of component children in order to manipulate the array without touching the incoming props
     * the array manipulation is required when the carousel show more than a slide per time
     */
    const nextChildren = children === null || children === void 0 ? void 0 : children.map((i) => (0, react_1.cloneElement)(i));
    /**
     * The groupChildrenArray return children as is if slidesPerView === 1
     * else it will group the slides based on slidesPerView value
     */
    const groupChildrenArray = (0, groupArray_1.groupArray)(nextChildren, slidesPerView);
    (0, react_1.useEffect)(() => {
        if (onChange) {
            onChange(selectedItemIndex, react_1.Children.toArray(children)[selectedItemIndex]);
        }
    }, [centeredSlides, children, onChange, selectedItemIndex, slidesPerView]);
    const changeItem = (newIndex) => () => {
        if (onChange) {
            onChange(newIndex, react_1.Children.toArray(children)[newIndex]);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classContainerList, ref: carouselWrapperRef }, rest, { style: Object.assign({}, style) }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: wrapperClassList }, { children: (0, jsx_runtime_1.jsx)("ul", Object.assign({ className: classSliderList }, { children: groupChildrenArray &&
                        groupChildrenArray.map((item, index) => ((0, jsx_runtime_1.jsx)(components_1.CarouselItem
                        // eslint-disable-next-line react/no-array-index-key
                        , Object.assign({ className: slideClassName, selected: index === selectedItemIndex, previous: selectedItemIndex === groupChildrenArray.length - 1
                                ? index !== 0 && index === selectedItemIndex - 1
                                : index === selectedItemIndex - 1, next: selectedItemIndex === groupChildrenArray.length - 1
                                ? index === 0
                                : index === selectedItemIndex + 1, style: Object.assign({}, (0, calculateStyle_1.calculateStyle)(index, selectedItemIndex, loop, centeredSlides, children === null || children === void 0 ? void 0 : children.length)) }, { children: react_1.Children.map(item, (child) => child) }), `itemKey${index}`))) })) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "carousel-buttons-container" }, { children: buttons })), showPagination && ((0, jsx_runtime_1.jsx)(components_1.CarouselPagination, { itemsNumber: groupChildrenArray.length, onClick: changeItem, selectedItemIndex: selectedItemIndex }))] })));
};
Carousel.defaultProps = defaultProps;
const CarouselExport = Object.assign(react_1.default.memo(Carousel), {
    Button: CarouselButton_1.default,
});
exports.default = CarouselExport;
